module.exports = __webpack_public_path__ + "img/sample.9a468e55.png";